/**
 * Default consent values used when no Ketch consent state is available.
 *
 * Decision record: "12 - Default Consent Policy" (Option 3)
 * https://skyscanner.atlassian.net/wiki/spaces/CONSENT/pages/2983461584/12+-+Default+Consent+Policy
 *
 * Deny-by-default policy: while the traveller's consent state is unknown -
 * for example a new traveller before Ketch has resolved consent - consent
 * dependent processing defaults to `false` in every market.
 *
 * `false` here is the safe default for an UNKNOWN consent state. It does not
 * represent an explicit rejection by the traveller. Once a consent state is
 * available from Ketch, Ketch is the source of truth and replaces these
 * defaults.
 *
 * Scope: Ketch mode only. Legacy (skyscanner) CMP mode continues to use the
 * market-derived defaults in isomorphic.ts
 * (NON_REGULATED_MARKET_DEFAULTS / REGULATED_MARKET_DEFAULTS).
 */

export const DEFAULT_INFORMATION_CONSENT = false;
export const DEFAULT_ADVERTS_CONSENT = false;
